//@ts-ignore
import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers';
import { BoardPlugin } from 'app/scripts/models/BoardPlugin';

//@ts-ignore
class BoardPluginList extends CollectionWithHelpers {
  static initClass() {
    this.prototype.model = BoardPlugin;
  }

  // @ts-ignore
  initialize(list, { board }) {
    return (this.board = board);
  }

  url() {
    return `/1/boards/${this.board.id}/boardPlugins`;
  }
}
BoardPluginList.initClass();

export { BoardPluginList };
